import React from 'react';
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRotate } from '@fortawesome/free-solid-svg-icons';

const Loading = () => {
  const { loading } = useSelector((state) => state.mx_assembly)

  const className = classnames({
    'pcb-loading-overlay': true,
    hidden: !loading,
  })

  return (
    <div className={className}>
      <div className="spin">
        <FontAwesomeIcon icon={faRotate} spin />
      </div>
    </div>
  )
}

export default Loading;